import { notify } from "../reducers/NotifierReducer";

export const asyncThunkWrapper = async ({
  dispatch,
  types: { request, success, failure },
  apiCall,
  onSuccess = () => {},
  transformResult = (res) => res,
  successMessage = "",
  errorMessagePrefix = "",
}) => {
  dispatch({ type: request });
  try {
    const result = await apiCall();
    const payload = transformResult(result);

    dispatch({ type: success, payload });
    onSuccess(payload);

    if (successMessage) dispatch(notify(successMessage, "success"));
    return payload;
  } catch (error) {
    dispatch({ type: failure, payload: error.message });
    if (error.code !== 401 && errorMessagePrefix) {
      dispatch(notify(`${errorMessagePrefix}: ${error.message}`, "error"));
      error.context = { skipNotification: true };
    }
    return null;
  }
};
